module.exports = __webpack_public_path__ + "static/media/hydroponics_systems_dutch_bucket3.7a08d3c4.webp";